<template>
  <div class="add-pay-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="130px">
        <el-form-item label="金币名称:" prop="name">
          <el-input v-model="params.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="购买金币数:" prop="coins">
          <el-input v-model.number="params.coins" size="small"></el-input>
        </el-form-item>
        <el-form-item label="赠送金币数:" prop="giveGold">
          <el-input v-model.number="params.giveGold" size="small"></el-input>
        </el-form-item>
        <el-form-item label="价格:" prop="price">
          <el-input v-model.number="params.price" size="small"></el-input>
        </el-form-item>
        <el-form-item label="激活:">
          <el-switch v-model="params.isActive">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      params: {
        name: '',
        coins: '',
        price: '',
        isActive: false,
        giveGold: ''
      },
      rules: {
        giveGold: [
        { required: true, message: '请输入赠送金币', trigger: 'blur' },

        ],
        name: [
          { required: true, message: '请输入配置名', trigger: 'blur' },
        ],
        coins: [
          { required: true, message: '请输入金币', trigger: 'blur' },
          { type: 'number', message: '金币必须为数字' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { type: 'number', message: '价格必须为数字' }
        ]
      }
    }
  },
  methods: {
    // 提交修改
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.flag = true
          if (this.title === '新增金币配置') {
            this.addGold()
          } else {
            this.editGold()
          }
        } else {
          return false
        }
      })
    },
    // 修改金币配置
    editGold() {
      let params = Object.assign({},this.params, { id: this.id,price: this.params.price * 100 })
      API.updateGold(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '修改金币配置成功',
            type: 'success'
          })
          this.$emit('handlerGoldList')
        } else {
          this.$message.error('修改金币配置失败')
        }
        this.flag = false
        this.handleClose()
      }).catch(() => {
        this.flag = false
        this.handleClose()
      })
    },
    // 添加金币配置
    addGold() {
      let params = Object.assign({},this.params, { price: this.params.price * 100 })
      API.addGold(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增金币配置成功',
            type: 'success'
          })
          this.$emit('handlerGoldList')
        } else {
          this.$message.error('新增金币配置失败')
        }
        this.flag = false
        this.handleClose()
      }).catch(() => {
        this.flag = false
        this.handleClose()
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        name: '',
        coins: '',
        price: '',
        giveGold: '',
        isActive: false
      }
      this.$refs['form'].resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑金币配置'
        this.params.name = data.name
        this.params.giveGold = data.giveGold || 0
        this.params.coins = data.coins
        this.params.price = data.price /100
        this.params.isActive = data.isActive
        this.id = data.id
      } else {
        this.title = '新增金币配置'
      }
    }
  }

}
</script>

<style lang="scss" >
.add-pay-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
